import * as marietta3d from '../../../marietta3d';

class AreaDataCollection {
    floor1Space: number;

    floor2Space: number;

    floor3Space: number;

    floorSpace: number;

    floor1ConstructionArea: number;

    flofloor2ConstructionArea: number;

    floor3ConstructionArea: number;

    floorConstructionArea: number;

    _entrance: string;

    fentranceEn: string;

    set entrance(str: string) {
      this._entrance = str;

      switch (this._entrance) {
        case '東': this.fentranceEn = 'east'; break;
        case '西': this.fentranceEn = 'west'; break;
        case '南': this.fentranceEn = 'south'; break;
        case '北': this.fentranceEn = 'north'; break;
        default: break;
      }
    }

    get entrance(): string {
      return this._entrance;
    }

    get entranceString(): string {
      switch (this.entrance) {
        case '東': return 'east';
        case '西': return 'west';
        case '南': return 'south';
        case '北': return 'north';
        default: break;
      }
      return 'north';
    }

    rooms: string;

    frontage: number;

    depth: number;

    /**
     * コンスト
     */
    constructor() {
      this.floor1Space = 0;
      this.floor2Space = 0;
      this.floor3Space = 0;
      this.floorSpace = 0;
      this.floor1ConstructionArea = 0;
      this.flofloor2ConstructionArea = 0;
      this.floor3ConstructionArea = 0;
      this.floorConstructionArea = 0;
      this.entrance = '';
      this.rooms = '';
      this.frontage = 0;
      this.depth = 0;
    }

    /**
     * PlanAreaInfoからデータを設定
     */
    importFromPlanAreaInfo(info: marietta3d.AutoGen.PlanAreaInfo): void {
      this.floor1Space = Math.round(info.yukaMenseki[1] * 100) / 100;
      this.floor2Space = Math.round(info.yukaMenseki[2] * 100) / 100;
      this.floor3Space = Math.round(info.yukaMenseki[3] * 100) / 100;
      this.floorSpace = Math.round((info.yukaMenseki[1] + info.yukaMenseki[2] + info.yukaMenseki[3]) * 100) / 100;
      this.floor1ConstructionArea = Math.round(info.koujiMenseki[1] * 100) / 100;
      this.flofloor2ConstructionArea = Math.round(info.koujiMenseki[2] * 100) / 100;
      this.floor3ConstructionArea = Math.round(info.koujiMenseki[3] * 100) / 100;
      this.floorConstructionArea = Math.round((info.koujiMenseki[1] + info.koujiMenseki[2] + info.koujiMenseki[3]) * 100) / 100;
      switch (info.genkanhoko) {
        case 1: this.entrance = '東'; break;
        case 2: this.entrance = '西'; break;
        case 3: this.entrance = '南'; break;
        case 4: this.entrance = '北'; break;
        default: this.entrance = '-'; break;
      }
      this.rooms = String(info.roomCount);
      this.frontage = info.maguchi / 1000;
      this.depth = info.okuyuki / 1000;
    }
}
export default AreaDataCollection;
